<div #mapContainer class="map-container">
  <div class="flotante">
    <div class="row-flex-start" style="gap: 8px">
      <!-- Botón para dibujar círculo -->
      <button
        irxBoton="tonal"
        [activo]="dibujando"
        type="button"
        (click)="dibujar()"
        [disabled]="dibujando"
      >
        <mat-icon>add_circle</mat-icon>
        Dibujar círculo
      </button>

      <!-- Botón para parar dibujo -->
      @if (dibujando) {
        <button
          irxBotonIcono
          tono="peligro"
          type="button"
          (click)="parar()"
          tooltip="Cancelar dibujo"
        >
          <mat-icon>clear</mat-icon>
        </button>
      }

      <!-- Botón para borrar todo -->
      @if (circle) {
        <button
          irxBotonIcono
          tono="peligro"
          type="button"
          (click)="borrar()"
          tooltip="Borrar círculo"
        >
          <mat-icon>delete</mat-icon>
        </button>
      }
    </div>

    <!-- Instrucciones de dibujo -->
    @if (dibujando) {
      <div class="draw-instructions">
        <mat-icon>info</mat-icon>
        <span>
          @if (!tempCircleCenter) {
            <strong>
              1. Click en el mapa para establecer el centro del círculo
            </strong>
          } @else {
            <strong>
              2. Mueve el mouse para ajustar el radio y haz click para finalizar
            </strong>
          }
        </span>
      </div>
    }
  </div>
</div>
